import axios from 'axios'
import imagesLoaded from 'imagesloaded'

class QuickView {
    constructor (theme, elem) {
        this.elem = elem
        this.theme = theme
        this.popupElem = document.querySelector('[data-quick-view-popup]')
        this.popupContentElem = this.popupElem.querySelector('[data-quick-view-render')
    }

    onInit () {
        let originalText = this.elem.textContent
        this.elem.addEventListener('click', (e) => {
            e.preventDefault()
            this.elem.textContent = 'Loading...'
            this.elem.setAttribute('disabled', 'disabled')
            let url = this.elem.dataset.quickView

            axios.get(url).then((response) => {
                this.popupContentElem.innerHTML = response.data
                imagesLoaded(this.popupElem, () => {
                    this.theme.registerComponents(this.popupElem)
                })
                this.popupElem.classList.add('shown')
                this.elem.textContent = originalText
                this.elem.removeAttribute('disabled')
            })
        })
    }
}

export default QuickView



// WEBPACK FOOTER //
// ./src/resources/scripts/components/QuickView.js